<template>
    <v-app-bar app color="white" light flat>
        <router-link :to="{name: 'home'}">
            <v-img alt="Logo" class="shrink" contain src="@/assets/ravenpod-text.png" transition="none" width="200"/>
        </router-link>
        <v-spacer></v-spacer>
        <v-btn active-class="no-active" text :to="{ name: 'ravenpodCrystal' }" >{{ $t('public_header.ravenpod_crystal') }}</v-btn>
        <v-btn active-class="no-active" text :to="{ name: 'pricing' }" >{{ $t('public_header.pricing') }}</v-btn>
        <v-menu open-on-hover bottom offset-y>
            <template v-slot:activator="{ on, attrs }"><v-btn text v-bind="attrs" v-on="on">{{ $t('public_header.help_center') }}</v-btn></template>
            <v-list>
                <v-list-item href="https://docs.ravenpod.com/guide" target="_blank">
                <v-list-item-title>{{ $t('public_header.docs') }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <v-menu open-on-hover bottom offset-y>
            <template v-slot:activator="{ on, attrs }"><v-btn text v-bind="attrs" v-on="on">{{ $t('public_header.about') }}</v-btn></template>
            <v-list>
                <v-list-item :to="{ name: 'about' }">
                    <v-list-item-title>{{ $t('public_header.about_ravenpod') }}</v-list-item-title>
                </v-list-item>
                <v-list-item :to="{ name: 'contact' }">
                    <v-list-item-title>{{ $t('public_header.contact_us') }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <!--
        <v-btn rounded :to="{ name: 'auth', params: { initAuthState: 'signup' } }" class="mx-3" large color="primary">{{ $t('public_header.sign_up') }}</v-btn>
        <v-btn rounded :to="{ name: 'auth', params: { initAuthState: 'signin' } }" class="mx-3" large outlined color="primary" >{{ $t('public_header.log_in') }}</v-btn>
        -->
    </v-app-bar>
</template>

<script>
    export default {
        name: 'PublicHeader',
        data: () => ({
        }),
    }
</script>
